// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2twxp","content":"styles_content__1zuLh","tableWrap":"styles_tableWrap__VSQbl"};